<template>
  <div class="card card-custom gutter-b">
    <div class="card-header">
      <div class="card-title">
        <div class="symbol symbol-40 mr-2 text-center">
          <img
            class="mx-auto"
            :alt="destinationTypes[destination.type]"
            :src="
              `/media/destinations/${destinationTypes[destination.type]}.png`
            "
          />
        </div>
        <h3 class="card-label">
          {{ destination.name }}
        </h3>
      </div>
      <div class="card-toolbar">
        <span class="font-family-base" dir="ltr">
          {{ formatDate(destination.updated_at) }}
        </span>
      </div>
    </div>
    <div class="card-body">
      <form id="form">
        <div class="form-group">
          <label>نام</label>
          <input
            type="text"
            name="name"
            v-model="form.name"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label>آدرس استریم</label>
          <input
            type="text"
            name="stream_url"
            dir="ltr"
            placeholder="Stream Url"
            v-model="form.details.stream_url"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label>کلید استریم</label>
          <input
            type="text"
            name="stream_key"
            dir="ltr"
            placeholder="Stream Key"
            v-model="form.details.stream_key"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label class="checkbox mb-0">
            <input
              type="checkbox"
              name="rotation"
              true-value="90"
              false-value="0"
              v-model="form.rotation"
            />
            <span class="mr-2"></span>
            چرخش ۹۰ درجه
          </label>
        </div>
        <div class="form-group">
          <label class="checkbox mb-0">
            <input
              type="checkbox"
              name="proxy_status"
              true-value="1"
              false-value="2"
              v-model="form.proxy_status"
            />
            <span class="mr-2"></span>
            استفاده از پروکسی
          </label>
        </div>
        <div class="form-group">
          <label class="checkbox mb-0">
            <input
              type="checkbox"
              name="auto_connect"
              true-value="1"
              false-value="0"
              v-model="form.auto_connect"
            />
            <span class="mr-2"></span>
            اتصال خودکار
          </label>
        </div>
        <div class="form-group" v-if="isAdmin || isCompany">
          <label class="checkbox mb-0">
            <input
              type="checkbox"
              name="editable"
              true-value="1"
              false-value="0"
              v-model="form.editable"
            />
            <span class="mr-2"></span>
            فابلیت وبرایش و حدف توسط کاربر
          </label>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import _ from "lodash";

export default {
  name: "EdCustomDestination",
  props: {
    isCompany: Boolean,
    isAdmin: Boolean
  },
  data() {
    return {
      changed: false,
      form: {}
    };
  },
  beforeMount() {
    this.form = _.cloneDeep(this.originalForm);
  },
  mounted() {
    this.fv = formValidation(document.getElementById("form"), {
      fields: {
        name: {
          validators: {
            notEmpty: {
              message: "نام صحیح نیست"
            },
            stringLength: {
              min: 2,
              max: 1000,
              message: "نام صحیح نیست"
            }
          }
        },
        stream_url: {
          validators: {
            notEmpty: {
              message: "آدرس استریم‌ الزامی است"
            },
            regexp: {
              regexp: /\w+:(\/?\/?)[^\s]+/,
              flags: "ig",
              message: "آدرس استریم‌ صحیح نیست"
            }
          }
        },
        stream_key: {
          validators: {
            notEmpty: {
              message: "کلید استریم‌ الزامی است"
            },
            stringLength: {
              min: 2,
              max: 1000,
              message: "کلید استریم‌ صحیح نیست"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  watch: {
    originalForm: {
      handler() {
        this.form = _.cloneDeep(this.originalForm);
      },
      deep: true
    },

    form: {
      handler() {
        this.$emit("change-form", _.isEqual(this.form, this.originalForm));
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["destinationTypes", "destination"]),
    originalForm() {
      return {
        id: this.destination.id,
        name: this.destination.name,
        details: {
          stream_url: this.destination.details.stream_url.toString(),
          stream_key: this.destination.details.stream_key.toString()
        },
        rotation: this.destination.rotation.toString(),
        proxy_status: this.destination.proxy_status.toString(),
        editable: this.destination.editable.toString(),
        auto_connect: this.destination.auto_connect.toString()
      };
    }
  }
};
</script>
